'use client';

import { create } from 'zustand';

import { MobileNavItem, TMobileNavStore } from './types';

export const useMobileNavbarStore = create<TMobileNavStore>((set) => ({
  data: MobileNavItem.Bank,
  setter: (data) => {
    set({ data });
  },
}));
